import pako from 'pako';

// Gunzips a given base-64 encoded string of gzipped content
export const gunzip = input => pako.inflate(atob(input), { to: 'string' });

// Gzips a given string and returns the base-64 encoded version
export const gzip = input => btoa(pako.gzip(input, { to: 'string' }));
